<template>
  <div class="questionnaires">
    <div v-if="curAge !== ''" class="q-links">
      <div
        class="q-link"
        style="margin-bottom: 1rem"
        v-for="quest in quests"
        :key="quest.pos"
      >
        <router-link
          class="btn btn-outline-primary btn-lg btn-block"
          v-if="showQuest(quest)"
          v-bind:to="'/erwthmatologio/' + slug(quest.title) + '/' + getme()"
          >{{ quest.title }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import Slugify from '@/lib/Slugify.js'
let questLevel = 0

export default {
  name: 'Questionnaires',
  inherit: true,
  data() {
    return {}
  },
  props: ['quests', 'curAge'],
  methods: {
    showQuest: function($quest) {
      /**
       * TODO: DOCUMENT THIS
       * !SHOULD IMPROVE
       */
      const _this = this

      let questLevelHasValue = false
      let theReturn = true

      $quest.levels.forEach(function(item, index) {
        theReturn = false
        if (_this.curAge >= item.ageFrom) {
          if (!(item.ageUntil > 0 && _this.curAge > item.ageUntil)) {
            questLevelHasValue = true
            questLevel = index
          }
        }
      })

      if (questLevelHasValue) {
        theReturn = true
      }

      return theReturn
    },
    getme: () => (questLevel !== 0 ? questLevel : ''),
    slug: $url => Slugify.make($url)
  }
}
</script>
